import "./DocumentsPanel.scss";

import { InlineSpinner } from "components/InlineSpinner";
import { LyneButton } from "components/Lyne/LyneButton";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { createLogger } from "logging";
import { useDocumentsPanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

import { ExistingDocuments } from "./ExistingDocuments";
import { UploadForm } from "./UploadForm";

const logger = createLogger("DocumentsPanel");

export const DocumentsPanel: React.FC = () => {
  logger.debug("render");
  const i18n = useTranslations();
  const { isOpen, agendaItem, isLoading, closeDocumentsPanel } = useDocumentsPanel();

  if (!isOpen) {
    return null;
  }

  if (!agendaItem) {
    return null;
  }

  const { isDeleted, headingNumber, title } = agendaItem;

  return (
    <SlidingPanel
      isOpen={true}
      size={50}
      onClose={closeDocumentsPanel}
      panelContainerClassName="documents-panel"
      header={<h1>{i18n.DocumentsPanel_Header}</h1>}
      footer={
        <div className="d-flex">
          <LyneButton onClick={closeDocumentsPanel} text={i18n.Actions_Close} kind="primary" />
        </div>
      }
    >
      <>
        <div className="documents-panel-agenda-item">
          <div>
            <b>{i18n.AgendaItem}:</b>
            <br />
            <span className={isDeleted ? "show-deleted" : ""}>
              {headingNumber}
              {". "}
              {title}
            </span>
            {isDeleted ? <span className="d-inline-block ml-2 text-danger fw-bold">{i18n.Deleted}</span> : null}
          </div>
        </div>

        {isLoading && <InlineSpinner text={i18n.DocumentsPanel_Loading} />}

        {!isLoading && (
          <>
            <ExistingDocuments />
            <UploadForm />
          </>
        )}
      </>
    </SlidingPanel>
  );
};
